"use client";
import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import Spinner from "../components/Common/Spinner";
import { Card, Button, Form, Row, Col } from "react-bootstrap";
import { getDepartments, getPEAK, getSTATS } from "../../services/Admin/adminServices";
import CountUp from "react-countup";
const Dashboards = () => {
  const [stats, setStats] = useState(null);
  const [peakPeriod, setPeakPeriod] = useState([]);
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [serviceDepartments, setServiceDepartments] = useState("");
  // Separate filter states
  const [statsFilters, setStatsFilters] = useState({
   
    startDate: "",
    endDate: "",
  });

 

  const [peakFilters, setPeakFilters] = useState({
    groupBy: "hour", 
    startDate: "",
    endDate: "",
  });

  const [reportList, setReportList] = useState([]);


 
  const fetchStats = async (query = "") => {
    // setLoading(true);
    try {
      const res = await getSTATS();
      const data = res?.data?.data;
      setStats(data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Peak Periods (applies peakFilters)
  const fetchPeakPeriods = async (query = "") => {
    // setLoading(true);
    try {
     
      // const res = await getPEAK(peakFilters.groupBy,peakFilters.startDate,peakFilters.endDate);
      // const data = res?.data?.data?.peakPeriods || [];
      // setPeakPeriod(data);
    } catch (error) {
      console.error("Error fetching peak periods:", error);
    } finally {
      setLoading(false);
    }
  };

 const fetchDepartments = async () => {
  try {
//     const res = await getDepartments();
//     const data = res?.data?.data?.departments.map(app => app.title) || [];
//  setDepartments(data);
  } catch (error) {
    console.error("Error fetching departments:", error);
  }
}
useEffect(() => {
  fetchDepartments()
}, []);



    useEffect(() => {
 
fetchPeakPeriods()
 
   
  }, [peakFilters.groupBy,peakFilters.endDate]);

 
 

   useEffect(() => {
 
fetchStats()
 
   
  }, [serviceDepartments, statsFilters.endDate]);


  // Handlers for Stats filter inputs
  const handleStatsFilterChange = (e) => {
    const { name, value } = e.target;
    setStatsFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Apply Stats filters (only affects stats & overview cards)
  const handleApplyStatsFilters = async () => {
    // setLoading(true);
    const query = new URLSearchParams(statsFilters).toString();
    await fetchStats(query ? `?${query}` : "");
    setLoading(false);
  };

  // Handlers for Peak filter inputs
  const handlePeakFilterChange = (e) => {
    const { name, value } = e.target;
    setPeakFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Apply Peak filters (only affects peak periods)
  const handleApplyPeakFilters = async () => {
    // setLoading(true);
    const query = new URLSearchParams(peakFilters).toString();
    await fetchPeakPeriods(query ? `?${query}` : "");
    setLoading(false);
  };



  // Prepare data
  const totalStats = stats?.totalStats || {};

  const statusData = (stats?.statusBreakdown || []).map((item) => ({
    name: item._id.charAt(0).toUpperCase() + item._id.slice(1),
    value: item.count,
  }));

  const deptData = (stats?.departmentBreakdown || []).map((item) => ({
  
    name: item._id,
    value: item.count,
  }));

 const peakData = (peakPeriod || []).flatMap((item) =>
  (item.departments || []).map((dept) => ({
    name: dept,   // this will be the X-axis label
    count: item.count,  // count of appointments for this department at this period
  }))
);
  // if (loading || !stats) return <Spinner />;
  return (
    <div className="container mt-4">
              <h1 className="mb-4" style={{color:"#64CAE5"}}>Dashboard</h1>
   
      {/* <Card className="p-3 mb-4 shadow-sm">
   
        <Row className="g-3 align-items-center">
          <Col md={4}>
           <select
        className="form-select"
        style={{ borderColor: "#64CAE5" }}
        value={serviceDepartments}
        onChange={(e) => setServiceDepartments(e.target.value)}
      >
        <option value="">All Services</option>
      
        {departments &&
          departments?.map((service, index) => (
            <option key={index} value={service}>
              {service}
            </option>
          ))}
      </select>
          </Col>

          <Col md={3}>
            <Form.Control
              type="date"
              name="startDate"
              value={statsFilters.startDate}
              onChange={handleStatsFilterChange}
            />
          </Col>

          <Col md={3}>
            <Form.Control
              type="date"
              name="endDate"
              value={statsFilters.endDate}
              onChange={handleStatsFilterChange}
            />
          </Col>

       
        </Row>
      </Card> */}

      {/* Overview Cards (driven by stats) */}
    <div className="row mb-4 flex-nowrap overflow-auto">
  <div className="col-3">
    <Card className="text-center p-3 bg-light shadow-sm">
      <h5>Total Users</h5>
         <CountUp
          start={0}
          end={stats?.totalUser || 0}
          duration={2}
        />
    </Card>
  </div>
  <div className="col-3">
    <Card className="text-center p-3 bg-success text-white shadow-sm">
      <h5>Total Vendors</h5>
         <CountUp
          start={0}
          end={stats?.totalVendor || 0}
          duration={2}
        />
    </Card>
  </div>
 
</div>




      {/* Status Breakdown chart (uses statsFilters result) */}

      {statusData.length>0 ?    <div className="mb-5">
        <h4 className="mb-3">Appointment Status Breakdown</h4>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={statusData} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
            <XAxis dataKey="name" label={{ value: "Status", position: "insideBottom", offset: -5 }} />
            <YAxis allowDecimals={false} label={{ value: "Count", angle: -90, position: "insideLeft" }} />
            <Tooltip />
           
            <Bar dataKey="value" fill="#64CAE5" />
          </BarChart>
        </ResponsiveContainer>
      </div>:""}




   













{/* {deptData.length > 0  ?   <div className="mb-5">
        <h4 className="mb-3">Department Breakdown</h4>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={deptData}>
            <XAxis dataKey="name" label={{ value: "Departments", position: "insideBottom", offset: -5 }} />
            <YAxis allowDecimals={false} label={{ value: "Count", angle: -90, position: "insideLeft" }} />
            <Tooltip />
           
            <Bar dataKey="value" fill="#64CAE5" />
          </BarChart>
        </ResponsiveContainer>
      </div> :""} */}
      {/* Department Breakdown chart (uses statsFilters result) */}
  

 
      {/* <Card className="p-3 mb-4 shadow-sm">
        <h5 className="mb-3 text-primary">Filter: Peak Appointment Periods</h5>
        <Row className="g-3 align-items-center">
          <Col md={3}>
            <Form.Select
              name="groupBy"
              value={peakFilters.groupBy}
              onChange={handlePeakFilterChange}
            >
              <option value="hour">hour</option>
              <option value="month">month</option>
              <option value="day">day</option>
                <option value="week">week</option>
            </Form.Select>
          </Col>

          <Col md={3}>
            <Form.Control
              type="date"
              name="startDate"
              value={peakFilters.startDate}
              onChange={handlePeakFilterChange}
            />
          </Col>

          <Col md={3}>
            <Form.Control
              type="date"
              name="endDate"
              value={peakFilters.endDate}
              onChange={handlePeakFilterChange}
            />
          </Col>

       
        </Row>
      </Card> */}


 
  {/* {peakPeriod.length > 0 ? (
<div className="mb-5">
  <h4 className="mb-3">Peak Appointment Periods (by {peakFilters.groupBy || "hour"})</h4>


    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={peakPeriod.flatMap((item) =>
          (item.departments || []).map((dept) => ({
            name: dept,       // X-axis label
            count: item.count // Y-axis value
          }))
        )}
        margin={{ top: 20, right: 30, left: 20, bottom: 40 }}
      >
        <XAxis
          dataKey="name"
          label={{ value: "Departments", position: "insideBottom", offset: -5 }}
          interval={0}
        />
        <YAxis
          allowDecimals={false}
          label={{ value: "Count", angle: -90, position: "insideLeft" }}
        />
        
        <Bar dataKey="count" fill="#64CAE5">
          <LabelList
            dataKey="count"
            position="top"
            style={{ fontSize: 12, fill: "#333" }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  
</div>) : (
    <p>No peak period data available</p>
  )}
  */}
    </div>
  );
};

export default Dashboards;
